import ScrollReveal from 'scrollreveal'

const SELECTORS = {
    scrollReveal: '.scrollReveal'
}

const CLASSES = {
    revealing: 'isRevealing',
    revealed: 'isRevealed'
}

export default class ScrollRevealer {
    constructor () {
        this.isLoaded = false
    }

    initialize () {
        this.elems = Array.from( document.querySelectorAll(SELECTORS.scrollReveal) )
        // console.table(this.elems)

        // Add class to <html> if ScrollReveal is supported
        // if (!sr.noop) {
        if (!ScrollReveal().noop) {
            Util.addClass(document.documentElement, 'sr')
        }

        this.isInit()
    }

    init () {
        const initScrollRevealForElem = elem => {
            const isImage = Util.hasClass(elem, 'shortblockimage')

            //----------------------------
            // DEFAULT CONFIG

            // 'bottom', 'left', 'top', 'right'
            var origin = 'bottom'

            // Can be any valid CSS distance, e.g. '5rem', '10%', '20vw', etc.
            var distance = '40px'

            // Time in milliseconds.
            var duration = variables.transition_slow;
            var delay = 0

            // Starting angles in degrees, will transition from these values to 0 in all axes.
            var rotateX, rotateY, rotateZ = 0
            if (isImage) {
                rotateX = 5
            }

            // Starting opacity value, before transitioning to the computed opacity.
            var opacity = 0

            // Starting scale value, will transition from this value to 1
            var scale = 1
            if (isImage) {
                scale = 1.2
            }

            // Accepts any valid CSS easing, e.g. 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out'
            var easing = 'cubic-bezier(.77,0,.175,1)'

            // true:  reveals occur every time elements become visible
            // false: reveals occur once as elements become visible
            var reset = false

            // When null, `<html>` is assumed to be the reveal container. You can pass a
            // DOM node as a custom container, e.g. document.querySelector('.fooContainer')
            // or a selector, e.g. '.fooContainer'
            // var container = null

            // Change when an element is considered in the viewport. The default value
            // of 0.20 means 20% of an element must be visible for its reveal to occur.
            var viewFactor = 0.15

            // Pixel values that alter the container boundaries.
            // e.g. Set `{ top: 48 }`, if you have a 48px tall fixed toolbar.
            // --
            // Visual Aid: https://scrollrevealjs.org/assets/viewoffset.png
            // var viewOffset = { top: 55, right: 55, bottom: 55, left: 55 }
            var viewOffset = { top: 0, right: 0, bottom: 0, left: 0 }


            //----------------------------
            // CUSTOM CONFIG

            if (elem.dataset.srOrigin) {
                origin = elem.dataset.srOrigin
            }
            if (elem.dataset.srDistance) {
                distance = elem.dataset.srDistance
            }
            if (elem.dataset.srDuration) {
                duration = parseIn(elem.dataset.srDuration)
            }
            if (elem.dataset.srDelay) {
                delay = parseInt(elem.dataset.srDelay)
            }
            if (elem.dataset.srRotateX) {
                rotateX = elem.dataset.srRotateX
            }
            if (elem.dataset.srRotateY) {
                rotateY = elem.dataset.srRotateY
            }
            if (elem.dataset.srRotateZ) {
                rotateZ = elem.dataset.srRotateZ
            }
            if (elem.dataset.srOpacity) {
                opacity = elem.dataset.srOpacity
            }
            if (elem.dataset.srScale !== undefined) {
                scale = elem.dataset.srScale
            }
            if (elem.dataset.srEasing) {
                easing = elem.dataset.srEasing
            }
            if (elem.dataset.srReset) {
                reset = elem.dataset.srReset
            }
            // if (elem.dataset.srContainer) {
            //  container = elem.dataset.srContainer
            // }

            var rotate = { x: rotateX, y: rotateY, z: rotateZ }

            // // console.groupCollapsed(`${elem}`)
            // console.groupCollapsed('ScrollReveal elem')
            // debug('elem: ', elem)
            // debug('origin: %s', origin)
            // debug('distance: %s', distance)
            // debug('duration: %s', duration)
            // debug('delay: %s', delay)
            // debug('rotate: ', rotate)
            // debug('opacity: %s', opacity)
            // debug('scale: %s', scale)
            // debug('easing: %s', easing)
            // console.groupEnd('ScrollReveal elem')


            //----------------------------
            // SCROLL REVEAL CALL
            // sr.reveal(elem, {
            ScrollReveal().reveal(elem, {
                origin      : origin,
                distance    : distance,
                duration    : duration,
                delay       : delay,
                rotate      : rotate,
                opacity     : opacity,
                scale       : scale,
                easing      : easing,
                reset       : reset,
                // container   : container,
                viewFactor  : viewFactor,
                viewOffset  : viewOffset,
                beforeReveal: (el) => {
                    // debug('beforeReveal ', el)
                    // el.classList.remove(CLASSES.revealed)
                    Util.addClass(el, CLASSES.revealing)

                    setTimeout(() => {
                        Util.removeClass(el, CLASSES.revealing)
                        Util.addClass(el, CLASSES.revealed)
                    }, duration + delay)
                },
                // beforeReset : (el) => {
                //     // debug('beforeReset ', el)
                //     Util.removeClass(el, CLASSES.revealed)
                //     // Util.addClass(el, CLASSES.revealing)
                // },
                // afterReveal : (el) => {
                //     debug('afterReveal ', el)
                //     // Util.removeClass(el, CLASSES.revealing)
                //     Util.addClass(el, CLASSES.revealed)
                // },
                // afterReset : (el) => {
                //     debug('afterReset ', el)
                //     Util.removeClass(el, CLASSES.revealing)
                //     Util.addClass(el, CLASSES.revealed)
                // }
            })
        }

        this.elems.forEach( item => initScrollRevealForElem(item) )
    }

    isInit () {
        this.isLoaded = true
        App.loadProgress += 1
        App.checkAppLoaded()
    }
}
